import React from 'react';

/**
 * Empty state component for TodoListView
 * 
 * @param showArchived - Whether viewing archived items
 * @param isFiltered - Whether filters are active (results in "no matching" vs "no missions")
 * @param onShowAddMissionArrow - Callback to show arrow pointing to Mission button
 */
const TodoListEmpty = ({ showArchived, isFiltered = false, onShowAddMissionArrow }) => {
  const getTitle = () => {
    if (showArchived) return 'No archived missions';
    if (isFiltered) return 'No matching missions';
    return 'No missions yet';
  };

  return (
    <div className="todolist-view__empty">
      <div className="todolist-view__empty-icon">✅</div>
      <h3 className="todolist-view__empty-title">{getTitle()}</h3>
      <p className="todolist-view__empty-text">
        {showArchived ? (
          'Archived missions will appear here'
        ) : isFiltered ? (
          'Try changing your filter'
        ) : (
          <>
            Click{' '}
            <button 
              className="todolist-view__empty-link" 
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onShowAddMissionArrow?.();
              }}
            >
              Add Mission
            </button>
            {' '}to create your first mission
          </>
        )}
      </p>
    </div>
  );
};

export default TodoListEmpty;
